import { httpBatchLink } from "@trpc/client";
import trpc from "../utils/trpc.js";
import { queryClient } from "./query";
import SuperJSON from "superjson";
import { useMemo } from "react";

const TRPCProvider = ({ children }: { children: React.ReactNode }) => {
  const trpcClient = useMemo(
    () =>
      trpc.createClient({
        links: [
          httpBatchLink({
            // httpLink({
            transformer: SuperJSON,
            url: `/api/trpc`,
            headers() {
              const sessionToken = sessionStorage.getItem("sessionToken");

              const headers: HeadersInit = sessionToken ? { Authorization: `Bearer ${sessionToken}` } : {};
              return headers;
            },
            fetch: async (input, init?) => {
              return fetch(input, {
                ...init,
                credentials: "include",
              });
            },
          }),
        ],
      }),
    [],
  );

  return (
    <trpc.Provider client={trpcClient} queryClient={queryClient}>
      {children}
    </trpc.Provider>
  );
};

export default TRPCProvider;
